import { render } from "./TheSearch.vue?vue&type=template&id=faad0f04&scoped=true"
import script from "./TheSearch.vue?vue&type=script&lang=js"
export * from "./TheSearch.vue?vue&type=script&lang=js"

import "./TheSearch.vue?vue&type=style&index=0&id=faad0f04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faad0f04"]])

export default __exports__